"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var async_1 = require("@shopify/async");

var Async_1 = require("./Async");

function createAsyncComponent(_a) {
  var id = _a.id,
      load = _a.load,
      defer = _a.defer,
      renderLoading = _a.renderLoading,
      _b = _a.renderPreload,
      renderPreload = _b === void 0 ? noopRender : _b,
      _c = _a.renderPrefetch,
      renderPrefetch = _c === void 0 ? noopRender : _c,
      _d = _a.renderKeepFresh,
      renderKeepFresh = _d === void 0 ? noopRender : _d;

  function AsyncComponent(props) {
    // Can't create a spread from union type, so opt for a function that
    // does the dirty casting for us.
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    return React.createElement(Async_1.Async, tslib_1.__assign({
      load: load,
      id: id,
      defer: defer,
      renderLoading: renderLoading,
      render: function render(Component) {
        return Component ? React.createElement(Component, tslib_1.__assign({}, componentProps)) : null;
      }
    }, asyncProps));
  }

  function Preload(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    return React.createElement(React.Fragment, null, renderPreload(componentProps), React.createElement(Async_1.Async, tslib_1.__assign({
      defer: async_1.DeferTiming.Idle,
      load: load
    }, asyncProps)));
  }

  function Prefetch(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    return React.createElement(React.Fragment, null, renderPrefetch(componentProps), React.createElement(Async_1.Async, tslib_1.__assign({
      defer: async_1.DeferTiming.Mount,
      load: load
    }, asyncProps)));
  }

  function KeepFresh(props) {
    var _a = tslib_1.__read(splitProps(props), 2),
        componentProps = _a[0],
        asyncProps = _a[1];

    return React.createElement(React.Fragment, null, renderKeepFresh(componentProps), React.createElement(Async_1.Async, tslib_1.__assign({
      defer: async_1.DeferTiming.Idle,
      load: load
    }, asyncProps)));
  } // Once we upgrade past TS 3.1, this will no longer be necessary,
  // because you can statically assign values to functions and TS
  // will know to augment its type


  var FinalComponent = AsyncComponent;
  FinalComponent.Preload = Preload;
  FinalComponent.Prefetch = Prefetch;
  FinalComponent.KeepFresh = KeepFresh;
  return FinalComponent;
}

exports.createAsyncComponent = createAsyncComponent;

function noopRender() {
  return null;
}

function splitProps(props) {
  var _a = props,
      async = _a.async,
      rest = tslib_1.__rest(_a, ["async"]);

  return [rest, async];
}